export const SUBSCRIPTION_STATE = {
  expired: 'EXPIRED',
};
